import { Core } from "@faire/design-tokens";
import { Column, HorizontalLine, Row } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import * as React from "react";
import styled from "styled-components";

import { accordionTransitionTiming } from "@faire/retailer/components/Accordion/Accordion";
import { AnimatedChevronContainer } from "@faire/retailer/components/Accordion/AnimatedChevronContainer";
import { ExpandedContent } from "@faire/retailer/components/Accordion/ExpandedContent";
import { FullControlAccordion } from "@faire/retailer/components/Accordion/FullControlAccordion";
import { Chevron } from "@faire/retailer/icons/Chevron/Chevron";

interface IProps {
  data: readonly AccordionInfo[];
  openIndex: number | undefined;
  onItemClick: (index: number) => void;
}

interface AccordionInfo {
  title: string;
  description: string;
}

export const Accordion: React.FC<IProps> = ({
  data,
  openIndex,
  onItemClick: toggleAccordionItem,
}) => {
  return (
    <Column flex={1} style={{ width: "100%" }}>
      {data.map(({ title, description }, index) => (
        <FullControlAccordion
          key={title}
          isOpen={openIndex === index}
          onClick={() => toggleAccordionItem(index)}
        >
          {index === 0 ? <HorizontalLine /> : null}
          <AccordionItem>
            <Row justify="space-between" align="center">
              <Typography
                color={Core.text.default}
                variant="subheadingSansRegular"
              >
                {title}
              </Typography>
              <AnimatedChevronContainer>
                <Chevron direction="right" height={12} width={12} />
              </AnimatedChevronContainer>
            </Row>
            <ExpandedContent>
              <Spacer size="2x" />
              <Typography
                color={Core.text.subdued}
                variant="paragraphSansMedium"
              >
                {description}
              </Typography>
            </ExpandedContent>
          </AccordionItem>
          <HorizontalLine />
        </FullControlAccordion>
      ))}
    </Column>
  );
};

const AccordionItem = styled.div`
  padding: ${getSpacing("2x", "4x")};

  ${accordionTransitionTiming}
`;
